<div class="multipoint-signer-contract">
  <div class="multipoint-signer-contract__header">
    <span class="multipoint-signer-contract__required">* {{ 'COMMONS.REQUIRED' | i18nextEager }}</span>
  </div>
  <section>
    <h2>{{ 'NEW_CONTRACTS.SIGNATURE_DATA' | i18nextEager }}</h2>
    <form [formGroup]="signerForm">
      <div class="multipoint-signer-contract__checkbox">
        <mat-checkbox (change)="handleCheckbox($event.checked)">
          {{ 'NEW_CONTRACTS.AUTOFILL' | i18nextEager }}
        </mat-checkbox>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.NAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="contactName" maxlength="50" />
        <mat-error *ngIf="
            signerForm?.controls.contactName?.errors?.required &&
            (signerForm.controls.contactName.touched || signerForm.controls.contactName.dirty)
          ">
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.SURNAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="contactSurname" maxlength="50" />
        <mat-error *ngIf="
            signerForm?.controls.contactSurname.errors?.required &&
            (signerForm.controls.contactSurname.touched || signerForm.controls.contactSurname.dirty)
          ">
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.DNI' | i18nextEager }}</mat-label>
        <input matInput formControlName="contactDocumentNumber" maxlength="9"
          placeholder="{{ isUserSpanish ? ('NEW_CONTRACTS.DNI_EXAMPLE' | i18nextEager) : '' }}" />
        <mat-error *ngIf="
            signerForm?.controls.contactDocumentNumber.errors?.required &&
            (signerForm.controls.contactDocumentNumber.touched || signerForm.controls.contactDocumentNumber.dirty)
          ">
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
        <mat-error *ngIf="
            (signerForm?.controls.contactDocumentNumber.errors?.invalid_dni ||
              signerForm?.controls.contactDocumentNumber.errors?.invalid_cif) &&
            (signerForm.controls.contactDocumentNumber.touched || signerForm.controls.contactDocumentNumber.dirty)
          ">
          {{ 'NEW_CONTRACTS.DNI_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACTS.EMAIL' | i18nextEager }}</mat-label>
        <input matInput formControlName="contactEmail" placeholder="{{ 'NEW_CONTRACTS.EMAIL_EXAMPLE' | i18nextEager }}"
          maxlength="50" />
        <mat-error *ngIf="
            signerForm?.controls.contactEmail.errors?.required &&
            (signerForm.controls.contactEmail.touched || signerForm.controls.contactEmail.dirty)
          ">
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
        <mat-error *ngIf="
            signerForm?.controls.contactEmail.errors &&
            signerForm?.controls.contactEmail.value &&
            (signerForm.controls.contactEmail.touched || signerForm.controls.contactEmail.dirty)
          ">
          {{ 'NEW_CONTRACTS.EMAIL_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <div class="multipoint-signer-contract__mobile-field">
        <div *ngIf="!isUserSpanish" class="multipoint-signer-contract__country-code">
          <app-custom-select [required]="true" [label]="'NEW_CONTRACTS.MOBILE_COUNTRY_CODE.LABEL'"
            [controlName]="'contactMobileCountryCode'" [values]="contactMobileCountryCodeList"
            [disabled]="signerForm.get('contactMobileCountryCode').disabled"
            [defaultValue]="signerForm.get('contactMobileCountryCode').value"></app-custom-select>
        </div>
        <div class="multipoint-signer-contract__mobile-input">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.MOBILE' | i18nextEager }}</mat-label>
            <input matInput formControlName="contactMobile" maxlength="9" numeric />
            <mat-error *ngIf="
                (signerForm?.controls.contactMobile.errors?.required ||
                  signerForm?.controls.contactMobile.errors?.invalid_mobile) &&
                (signerForm.controls.contactMobile.touched || signerForm.controls.contactMobile.dirty)
              ">
              {{ 'NEW_CONTRACTS.MOBILE_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </section>
  <section class="multipoint-signer-contract__section-campaign">
    <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.SELECT_CAMPAIGN' | i18nextEager }}</h2>
    <form [formGroup]="signerForm">
      <div class="multipoint-signer-contract__container-inputs">
        <div class="multipoint-signer-contract__select-date">
          <mat-radio-group aria-label="" formControlName="radioDate">
            <mat-radio-button value="1" [disabled]="signerForm.get('radioDate').disabled">
              {{ 'NEW_CONTRACTS.READING_CYCLE' | i18nextEager }}
            </mat-radio-button>
            <mat-radio-button value="2" [disabled]="signerForm.get('radioDate').disabled">
              {{ 'NEW_CONTRACTS.FUTURE_DATE' | i18nextEager }}
            </mat-radio-button>
          </mat-radio-group>
          <ng-container *ngIf="signerForm.get('radioDate').value === '2'">
            <mat-form-field #futureDateField appearance="outline" [ngClass]="{
                'multipoint-signer-contract__fix-label':
                  signerForm?.controls.invoiceDate.invalid &&
                  !(signerForm?.controls.invoiceDate.touched || signerForm?.controls.invoiceDate.dirty)
              }">
              <mat-label>{{ 'NEW_CONTRACTS.FUTURE_DATE' | i18nextEager }}</mat-label>
              <input formControlName="invoiceDate" matInput [matDatepicker]="picker" [min]="today" readonly />
              <img src="/assets/icons/calendar.svg" class="calendar-icon" (click)="picker.open()"
                alt="{{ 'COMMONS.CALENDAR' | i18nextEager }}" />
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="
                  signerForm?.controls.invoiceDate.errors?.required &&
                  (signerForm?.controls.invoiceDate.touched || signerForm?.controls.invoiceDate.dirty)
                ">
                {{ 'NEW_CONTRACTS.INVOICE_DATA_ERROR' | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </ng-container>
        </div>
        <app-custom-select [label]="'NEW_CONTRACTS.CAMPAIGN'" [controlName]="'campaign'" [values]="campaignList"
          [required]="true" [defaultValue]="signerForm.get('campaign').value" (onChange)="handleSelectCampaign($event)"
          [disabled]="signerForm.get('campaign').disabled"></app-custom-select>
        <div *ngIf="!isUserSpanish">
          <div class="multipoint-signer-contract__select-date">
            <mat-radio-group aria-label="" formControlName="payment">
              <mat-radio-button value="0" [disabled]="signerForm.get('payment').disabled">
                {{ 'NEW_CONTRACTS.DOMICILIATION' | i18nextEager }}
              </mat-radio-button>
              <mat-radio-button value="1" [disabled]="signerForm.get('payment').disabled">
                {{ 'NEW_CONTRACTS.MULTIBANK' | i18nextEager }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div *ngIf="showBankAccountFields" class="multipoint-signer-contract__select-date">
            <mat-radio-group aria-label="" formControlName="sameBankAccount">
              <mat-radio-button value="0" [disabled]="signerForm.get('sameBankAccount').disabled">
                {{ 'NEW_CONTRACTS.INSTALLATION_DATA.ALL_SAME' | i18nextEager }}
              </mat-radio-button>
              <mat-radio-button value="1" [disabled]="signerForm.get('sameBankAccount').disabled">
                {{ 'NEW_CONTRACTS.INSTALLATION_DATA.NOT_SAME' | i18nextEager }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div *ngFor="let installation of installations; let i = index">
            <span *ngIf="showBankAccountFields && signerForm.get('sameBankAccount')?.value !== '0'">{{ installation?.cups }}: </span>
            <div *ngIf="showBankAccountFields && signerForm.get('ibanCode' + '_' + i)" class="content account">
              <mat-form-field appearance="outline" id="ibanCode">
                <mat-label>{{ 'NEW_CONTRACTS.IBAN' | i18nextEager }}</mat-label>
                <input
                  matInput
                  uppercase
                  id="{{ 'ibanInput' + '_' + i }}"
                  maxlength="4"
                  [formControlName]="'ibanCode' + '_' + i"
                  (paste)="onPasteIBAN($event, i)"
                  (keyup)="bankAccountKeyUp($event, null, 'ibanInput', 'entityInput', i)"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" id="ibanEntity">
                <mat-label>{{ 'NEW_CONTRACTS.ENTITY' | i18nextEager }}</mat-label>
                <input
                  matInput
                  numeric
                  id="{{ 'entityInput' + '_' + i }}"
                  maxlength="4"
                  [formControlName]="'ibanEntity' + '_' + i"
                  (paste)="onPasteIBAN($event, i)"
                  (keyup)="bankAccountKeyUp($event, 'ibanInput', 'entityInput', 'officeInput', i)"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" id="ibanOffice">
                <mat-label>{{ 'NEW_CONTRACTS.OFFICE' | i18nextEager }}</mat-label>
                <input
                  matInput
                  numeric
                  id="{{ 'officeInput' + '_' + i }}"
                  maxlength="4"
                  [formControlName]="'ibanOffice' + '_' + i"
                  (paste)="onPasteIBAN($event, i)"
                  (keyup)="
                    bankAccountKeyUp(
                      $event,
                      'entityInput',
                      'officeInput',
                      'accountInput',
                      i
                    )
                  "
                />
              </mat-form-field>
              <mat-form-field appearance="outline" id="ibanAccount">
                <mat-label>{{ 'NEW_CONTRACTS.ACCOUNT' | i18nextEager }}</mat-label>
                <input
                  matInput
                  numeric
                  id="{{ 'accountInput' + '_' + i }}"
                  [formControlName]="'ibanAccount' + '_' + i"
                  [maxlength]="11"
                  (paste)="onPasteIBAN($event, i)"
                  (keyup)="
                    bankAccountKeyUp(
                      $event,
                      'officeInput',
                      'accountInput',
                      'dcInput',
                      i
                    )
                  "
                />
              </mat-form-field>
              <mat-form-field appearance="outline" id="ibanDC">
                <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
                <input
                  matInput
                  numeric
                  id="{{ 'dcInput' + '_' + i }}"
                  maxlength="2"
                  [formControlName]="'ibanDC' + '_' + i"
                  (paste)="onPasteIBAN($event, i)"
                  (keyup)="bankAccountKeyUp($event, 'accountInput', 'dcInput', null, i)"
                />
              </mat-form-field>
            </div>
            <mat-error
              class="account__error account__error-pt"
              *ngIf="
                showBankAccountFields &&
                (checkControlRequired('ibanCode' + '_' + i, i) ||
                checkControlRequired('ibanEntity' + '_' + i, i) ||
                checkControlRequired('ibanOffice' + '_' + i, i) ||
                checkControlRequired('ibanDC' + '_' + i, i) ||
                checkControlRequired('ibanAccount' + '_' + i, i))
              "
            >
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error class="account__error account__error-pt" *ngIf="showBankAccountFields && checkControlIban(i)">
              {{ 'NEW_CONTRACTS.IBAN_ERROR' | i18nextEager }}
            </mat-error>
          </div>
        </div>
        <app-custom-select *ngIf="!signerForm.get('campaignBase').value" [label]="'NEW_CONTRACTS.LEVEL'"
          [required]="true" [controlName]="'level'" [values]="levelList" [defaultValue]="signerForm.get('level').value"
          [disabled]="signerForm.get('level').disabled"></app-custom-select>
      </div>
      <ng-container *ngIf="signerForm.get('campaignBase').value">
        <!-- <div *ngIf="isFixedPrice" class="multipoint-signer-contract__container-radio">
          <h2>{{ 'NEW_CONTRACTS.CALCULATE_COMMISSION' | i18nextEager }}</h2>
          <div class="multipoint-signer-contract__container-inputs">
            <mat-radio-group aria-label="" formControlName="marginIndicator">
              <mat-radio-button value="1">
                {{ 'NEW_CONTRACTS.ENTER_MARGIN' | i18nextEager }}
              </mat-radio-button>
              <mat-radio-button *ngIf="isUserSpanish" value="2">
                {{ 'NEW_CONTRACTS.MARGIN_PRICE' | i18nextEager }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div> -->
        <app-multipoint-calculate-margin
          *ngIf="signerForm.get('marginIndicator').value === '1'"
          [campaignDetail]="campaignDetail"
          [greaterEqual100]="greaterEqual100"
          [installations]="installations"
          [passThrough]="passThrough"
          [fijoFlex]="fijoFlex"
          [fixPrice]="isFixedPrice"
          (enterMargins)="getEnterMargins($event)"
        ></app-multipoint-calculate-margin>
        <ng-container *ngIf="signerForm.get('marginIndicator').value === '2'" formGroupName="calculateMargins">
          <h2 class="multipoint-signer-contract__margin-top-24">
            {{ 'NEW_CONTRACTS.CALCULATE_MARGIN_PRICE' | i18nextEager }}
          </h2>
          <div
            class="multipoint-signer-contract__equalized-el multipoint-signer-contract__grid-col--8 multipoint-signer-contract__gap--20">
            <div class="multipoint-signer-contract__col-span--3">
              <app-custom-select class="width100" [label]="'NEW_CONTRACTS.CUPS'" [controlName]="'marginCups'"
                [values]="marginCups" [defaultValue]="signerForm?.get('marginCups')?.value">
              </app-custom-select>
            </div>
          </div>
          <div class="multipoint-signer-contract__equalized-el">
            <div class="multipoint-signer-contract__title-terms">
              {{ 'NEW_CONTRACTS.PRICE_TE' | i18nextEager }}
            </div>
          </div>
          <div
            class="multipoint-signer-contract__equalized-el multipoint-signer-contract__grid-col--8 multipoint-signer-contract__gap--20">
            <div class="multipoint-signer-contract__col-span--2">
              <app-custom-select class="width100" [label]="'NEW_CONTRACTS.UNITS_TE'" [controlName]="'unitsTE'"
                [values]="unitsTE" [defaultValue]="signerForm?.get('unitsTE')?.value">
              </app-custom-select>
            </div>
            <div class="multipoint-signer-contract__col-span--6">
              <div class="multipoint-signer-contract__grid-col--6 multipoint-signer-contract__gap--30"
                formGroupName="marginTE">
                <mat-form-field *ngFor="let number of isUserSpanish ? [1, 2, 3, 4, 5, 6] : [1, 2, 3, 4]"
                  appearance="outline" [ngClass]="{
                    'multipoint-signer-contract__fix-label': checkHaveError('calculateMargins.marginTE.p' + number)
                  }">
                  <mat-label>P{{ number }}</mat-label>
                  <input matInput [formControlName]="'p' + number" numberCustom [regex]="regexSixDecimal"
                    [formControl]="signerForm?.get('calculateMargins.marginTE.p' + number)" />
                  <mat-error *ngIf="checkRequiredError('calculateMargins.marginTE.p' + number)">
                    {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                  </mat-error>
                  <mat-error *ngIf="checkPatternError('calculateMargins.marginTE.p' + number)">
                    {{ 'NEW_CONTRACTS.ERROR_FORMAT_P' | i18nextEager }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div isUserSpanish class="multipoint-signer-contract__equalized-el">
            <div class="multipoint-signer-contract__title-terms">
              {{ 'NEW_CONTRACTS.PRICE_TP' | i18nextEager }}
            </div>
          </div>
          <div *ngIf="isUserSpanish"
            class="multipoint-signer-contract__equalized-el multipoint-signer-contract__grid-col--8 multipoint-signer-contract__gap--20">
            <div class="multipoint-signer-contract__col-span--2">
              <app-custom-select class="width100" [label]="'NEW_CONTRACTS.UNITS_TP'" [controlName]="'unitsTP'"
                [values]="unitsTP" [defaultValue]="signerForm?.get('unitsTP')?.value">
              </app-custom-select>
            </div>
            <div class="multipoint-signer-contract__col-span--6">
              <div class="multipoint-signer-contract__grid-col--6 multipoint-signer-contract__gap--30"
                formGroupName="marginTP">
                <mat-form-field *ngFor="let number of [1, 2, 3, 4, 5, 6]" appearance="outline" [ngClass]="{
                    'multipoint-signer-contract__fix-label': checkHaveError('calculateMargins.marginTP.p' + number)
                  }">
                  <mat-label>P{{ number }}</mat-label>
                  <input matInput [formControlName]="'p' + number" numberCustom [regex]="regexSixDecimal"
                    [formControl]="signerForm?.get('calculateMargins.marginTP.p' + number)" />
                  <mat-error *ngIf="checkRequiredError('calculateMargins.marginTP.p' + number)">
                    {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                  </mat-error>
                  <mat-error *ngIf="checkPatternError('calculateMargins.marginTP.p' + number)">
                    {{ 'NEW_CONTRACTS.ERROR_FORMAT_P' | i18nextEager }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div
            class="multipoint-signer-contract__equalized-el multipoint-signer-contract__grid-col--8 multipoint-signer-contract__gap--20">
            <div class="multipoint-signer-contract__col-span--2 multipoint-signer-contract__col-start--7">
              <button class="multipoint-signer-contract__button-query multipoint-signer-contract__button-query--top-30"
                [disabled]="!(signerForm?.get('calculateMargins').valid && signerForm?.get('marginCups').valid)"
                (click)="handleCalculate()">
                {{ 'NEW_CONTRACTS.CALCULATE' | i18nextEager }}
              </button>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="showCalculate && signerForm.get('marginIndicator').value === '2'">
          <h2 class="multipoint-signer-contract__margin-top-24">
            {{ 'NEW_CONTRACTS.RESULT_SIMULATION' | i18nextEager }}
          </h2>
          <div class="multipoint-signer-contract__tabs">
            <button mat-button *ngFor="let geographic of geographicZones; index as i" class="multipoint-signer-contract__button-tab"
              [ngClass]="geographicIndexTab === i ? 'secondary tabs__button--active' : 'terciary'" (click)="changeGeographicTab(i)">
              {{ geographic | uppercase }}
            </button>
          </div>
          <!-- <div *ngIf="signerForm.get('marginIndicator').value === '2' || canSettlements"
            class="multipoint-signer-contract__equalized-el  multipoint-signer-contract__col-span--10">
            <div class="multipoint-signer-contract__grid-col--3 multipoint-signer-contract__gap--30">
              <div *ngIf="canSettlements"
                class="multipoint-signer-contract__margin-label multipoint-signer-contract__grid-col--2">
                <div>
                  <span class="multipoint-signer-contract__margin-title ">
                    {{ 'NEW_CONTRACTS.COMMISSION' | i18nextEager }}
                  </span>
                  <div class="multipoint-signer-contract__container-margin ">
                    <span class="multipoint-signer-contract__margin-title">
                      €
                    </span>
                  </div>
                </div>
                <span class="multipoint-signer-contract__box-result">{{ commission | number: '1.0-2' }}</span>
              </div>
              <ng-container *ngIf="signerForm.get('marginIndicator').value === '2'">
                <div class="multipoint-signer-contract__margin-label multipoint-signer-contract__grid-col--2">
                  <div>
                    <span class="multipoint-signer-contract__margin-title ">
                      {{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }}
                    </span>
                    <div class="multipoint-signer-contract__container-margin ">
                      <span class="multipoint-signer-contract__margin-title">
                        €
                      </span>
                      <span class="multipoint-signer-contract__margin-subtitle">
                        {{ 'NEW_CONTRACTS.MW_HOUR_2' | i18nextEager }}
                      </span>
                    </div>
                  </div>
                  <span class="multipoint-signer-contract__box-result">{{ resultCalcTE | number: '1.0-2' }}</span>
                </div>
                <div *ngIf="isUserSpanish"
                  class="multipoint-signer-contract__margin-label multipoint-signer-contract__grid-col--2">
                  <div>
                    <span class="multipoint-signer-contract__margin-title ">
                      {{ 'NEW_CONTRACTS.MARGIN_TP' | i18nextEager }}
                    </span>
                    <div class="multipoint-signer-contract__container-margin ">
                      <span class="multipoint-signer-contract__margin-title">
                        €
                      </span>
                      <span class="multipoint-signer-contract__margin-subtitle">
                        {{ 'NEW_CONTRACTS.KW_ANY' | i18nextEager }}
                      </span>
                    </div>
                  </div>
                  <span class="multipoint-signer-contract__box-result">{{ resultCalcTP | number: '1.0-2' }}</span>
                </div>
              </ng-container>
            </div>
          </div> -->
          <table *ngFor="let fee of calculates; index as i">
            <h1>{{ fee.name }}</h1>
            <tr>
              <th id="price"></th>
              <th id="p1">P1</th>
              <th id="p2">P2</th>
              <th id="p3">P3</th>
              <th id="p4">{{ fee.name !==
                '2.0TD' ? 'P4' : '' }}</th>
              <th *ngIf="isUserSpanish" id="p5">{{ fee.name !==
                '2.0TD' ? 'P5' : '' }}</th>
              <th *ngIf="isUserSpanish" id="p6">{{ fee.name !==
                '2.0TD' ? 'P6' : '' }}</th>
            </tr>
            <tr *ngIf="fee && fee?.ai?.length > 0 && !passThrough && !fijoFlex">
              <td>
                Ai<span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
              </td>
              <td>{{ fee.ai[0] | number: '1.6-6' }}</td>
              <td>{{ fee.ai[1] | number: '1.6-6' }}</td>
              <td>{{ fee.ai[2] | number: '1.6-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.ai[3] : '') | number: '1.6-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.ai[4] : '') | number: '1.6-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.ai[5] : '') | number: '1.6-6' }}</td>
            </tr>
            <tr *ngIf="fee && fee?.ki?.length > 0 && !passThrough && !fijoFlex">
              <td>
                Ki
              </td>
              <td>{{ fee.ki[0] | number: '1.3-6' }}</td>
              <td>{{ fee.ki[1] | number: '1.3-6' }}</td>
              <td>{{ fee.ki[2] | number: '1.3-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.ki[3] : '') | number: '1.3-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.ki[4] : '') | number: '1.3-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.ki[5] : '') | number: '1.3-6' }}</td>
            </tr>
            <tr *ngIf="fee && fee?.tp?.length > 0 && !passThrough && !fijoFlex">
              <td>
                TP<span class="units">{{ 'COMMONS.EUROS_KW_YEAR' | i18nextEager }}</span>
              </td>
              <td>{{ fee.tp[0] | number: '1.6-6' }}</td>
              <td>{{ fee.tp[1] | number: '1.6-6' }}</td>
              <td>{{ fee.tp[2] | number: '1.6-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.tp[3] : '') | number: '1.6-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.tp[4] : '') | number: '1.6-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.tp[5] : '') | number: '1.6-6' }}</td>
            </tr>
            <tr *ngIf="passThrough || fijoFlex">
              <td>
                TP<span class="units">{{ 'COMMONS.EUROS_KW_YEAR' | i18nextEager }}</span>
              </td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P1 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P1 + +signerForm?.get('enterMargins.marginTP')?.value) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P2 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P2 + +signerForm?.get('enterMargins.marginTP')?.value) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P3 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P3 + +signerForm?.get('enterMargins.marginTP')?.value) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P4 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P4 + +signerForm?.get('enterMargins.marginTP')?.value) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P5 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P5 + +signerForm?.get('enterMargins.marginTP')?.value) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P6 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].tP_P6 + +signerForm?.get('enterMargins.marginTP')?.value) | number: '1.6-6')
              }}</td>
            </tr>
            <tr *ngIf="fee && fee?.te?.length > 0 && !passThrough && !fijoFlex">
              <td>
                TE<span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
              </td>
              <td>{{ fee.te[0] | number: '1.6-6' }}</td>
              <td>{{ fee.te[1] | number: '1.6-6' }}</td>
              <td>{{ fee.te[2] | number: '1.6-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.te[3] : '') | number: '1.6-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.te[4] : '') | number: '1.6-6' }}</td>
              <td>{{ (fee.name !== '2.0TD' ? fee.te[5] : '') | number: '1.6-6' }}</td>
            </tr>
            <tr *ngIf="passThrough && isUserSpanish">
              <td>
                <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.GDOS' | i18nextEager }}</span>
                <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
              </td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P1 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P1 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P2 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P2 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P3 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P3 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P4 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P4 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P5 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P5 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P6 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].gdOs_P6 / 1000) | number: '1.6-6')
              }}</td>
            </tr>
            <tr *ngIf="passThrough">
              <td>
                <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.CG' | i18nextEager }}</span>
                <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
              </td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P1 === null ? ''
                : (((isUserSpanish ? signerForm?.get('enterMargins.marginsTE')?.value
                : (campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P1 + signerForm?.get('enterMargins.marginsTE')?.value)) / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P2 === null ? ''
                : (((isUserSpanish ? signerForm?.get('enterMargins.marginsTE')?.value
                : (campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P2 + signerForm?.get('enterMargins.marginsTE')?.value)) / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P3 === null ? ''
                : (((isUserSpanish ? signerForm?.get('enterMargins.marginsTE')?.value
                : (campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P3 + signerForm?.get('enterMargins.marginsTE')?.value)) / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P4 === null ? ''
                : (((isUserSpanish ? signerForm?.get('enterMargins.marginsTE')?.value
                : (campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P4 + signerForm?.get('enterMargins.marginsTE')?.value)) / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P5 === null ? ''
                : (((isUserSpanish ? signerForm?.get('enterMargins.marginsTE')?.value
                : (campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P5 + signerForm?.get('enterMargins.marginsTE')?.value)) / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P6 === null ? ''
                : (((isUserSpanish ? signerForm?.get('enterMargins.marginsTE')?.value
                : (campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].cG_P6 + signerForm?.get('enterMargins.marginsTE')?.value)) / 1000) | number: '1.6-6')
              }}</td>
            </tr>
            <tr *ngIf="passThrough && isUserSpanish">
              <td>
                <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.FI' | i18nextEager }}</span>
                <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
              </td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P1 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P1 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P2 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P2 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P3 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P3 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P4 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P4 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P5 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P5 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P6 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].fi_P6 / 1000) | number: '1.6-6')
              }}</td>
            </tr>
            <tr *ngIf="fijoFlex && isUserSpanish">
              <td>
                <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.FIXED_PRICE' | i18nextEager }}</span>
                <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
              </td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P1 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P1 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P2 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P2 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P3 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P3 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P4 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P4 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P5 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P5 / 1000) | number: '1.6-6')
              }}</td>
              <td>{{
                campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P6 === null ? ''
                : ((campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P6 / 1000) | number: '1.6-6')
              }}</td>
            </tr>
            <tr *ngIf="fijoFlex && isUserSpanish">
              <td>
                <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.S_ADJUST' | i18nextEager }}</span>
                <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
              </td>
              <td>
                {{ campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P1 !== null ? ('CAMPAIGNS.CAMPAIGN-DETAIL.INDEX' | i18nextEager) : '' }}
              </td>
              <td>
                {{ campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P2 !== null ? ('CAMPAIGNS.CAMPAIGN-DETAIL.INDEX' | i18nextEager) : '' }}
              </td>
               <td>
                {{ campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P3 !== null ? ('CAMPAIGNS.CAMPAIGN-DETAIL.INDEX' | i18nextEager) : '' }}
              </td>
              <td>
                {{ campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P4 !== null ? ('CAMPAIGNS.CAMPAIGN-DETAIL.INDEX' | i18nextEager) : '' }}
              </td>
              <td>
                {{ campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P5 !== null ? ('CAMPAIGNS.CAMPAIGN-DETAIL.INDEX' | i18nextEager) : '' }}
              </td>
               <td>
                {{ campaignDetail.zonasGeograficas[this.geographicIndexTab].tarifas[i].pFijo_P6 !== null ? ('CAMPAIGNS.CAMPAIGN-DETAIL.INDEX' | i18nextEager) : '' }}
              </td>
            </tr>
          </table>
        </ng-container>
      </ng-container>
    </form>
  </section>
</div>